export type GameArea = {
    screenWidth: number;
    screenHeight: number;
    offset: {
        x: number;
        y: number;
    }
    scale: number;
}

const screenWidth = 1920;
const screenHeight = 1080;


export const gameArea: GameArea = {
    screenWidth: screenWidth,
    screenHeight: screenHeight,
    offset: {
        x: 512,
        y: 512
    },
    scale: 4
}